// DatabaseSettingsAddButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './DatabaseSettingsAddButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * DatabaseSettingsAddButton
 * 
 * Reusable add button component for database settings, used in both Views and Fields management.
 * Renders a button with an add icon and label, with hover and disabled states.
 * 
 * @param {string} title - The button title.
 * @param {boolean} disabled - Whether the button is disabled.
 * @param {function} onClick - Click handler for the button.
 * 
 * @returns {ReactNode} - DatabaseSettingsAddButton.
 */
const DatabaseSettingsAddButton = React.memo(({ title, disabled = false, onClick }) => {

    // ----- CONTEXT ----- //

    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover state
    const [hovered, setHovered] = useState(false);

    // ----- RENDER ----- //

    return (

        <div className="database-settings-add-button-container"
            style={{
                backgroundColor: hovered ? theme.backgroundHover : 'transparent',
                borderColor: hovered ? theme.foreground : theme.foregroundMuted,
                color: hovered ? theme.foreground : theme.foregroundMuted,
            }}
            onClick={disabled ? undefined : onClick}
            onMouseEnter={disabled ? undefined : () => setHovered(true)}
            onMouseLeave={disabled ? undefined : () => setHovered(false)}
            title={title}
        >
            {/* ICON */}
            <Icon
                iconKey="add"
                width={14}
                height={14}
                color={hovered ? theme.foreground : theme.foregroundMuted}
            />

            {/* LABEL */}
            <span>
                {title}
            </span>

        </div >
    );

});

// Dev Tools
DatabaseSettingsAddButton.displayName = 'DatabaseSettingsAddButton';

export default DatabaseSettingsAddButton;

